import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { LocaleProvider } from './contexts/LocaleContext';
import { AuthProvider } from './contexts/AuthContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import { FunnelProvider } from './contexts/FunnelContext';
import RequireAccess from './components/RequireAccess';
import AnalyticsSync from './components/AnalyticsSync';
import Layout from './pages/Layout';
import HomePage from './pages/HomePage';
import './styles/globals.css';
import './pages/Layout.css';

const MatchDetailPage = lazy(() => import('./pages/MatchDetailPage'));
const ChannelsPage = lazy(() => import('./pages/ChannelsPage'));
const StreamsPage = lazy(() => import('./pages/StreamsPage'));
const ScoresPage = lazy(() => import('./pages/ScoresPage'));
const NewsPage = lazy(() => import('./pages/NewsPage'));
const NewsArticlePage = lazy(() => import('./pages/NewsArticlePage'));
const PaywallPage = lazy(() => import('./pages/PaywallPage'));
const PaywallSuccessPage = lazy(() => import('./pages/PaywallSuccessPage'));
const AccountPage = lazy(() => import('./pages/AccountPage'));

const Guard = ({ children }) => <RequireAccess>{children}</RequireAccess>;

const RouteFallback = () => (
  <div className="initial-loading" style={{ minHeight: '40vh' }} aria-busy="true">
    <div className="loading-spinner" />
  </div>
);

const App = () => {
  return (
    <ThemeProvider>
      <LocaleProvider>
        <AuthProvider>
          <SubscriptionProvider>
            <FunnelProvider>
            <Router>
              <AnalyticsSync />
              <Layout>
                <Suspense fallback={<RouteFallback />}>
                  <Routes>
                    <Route path="/onboarding" element={<Navigate to="/" replace />} />
                    <Route path="/paywall" element={<PaywallPage />} />
                    <Route path="/paywall/success" element={<PaywallSuccessPage />} />
                    <Route path="/account" element={<AccountPage />} />

                    <Route path="/" element={<Guard><HomePage /></Guard>} />
                    <Route path="/streams" element={<Guard><StreamsPage /></Guard>} />
                    <Route path="/news" element={<Guard><NewsPage /></Guard>} />
                    <Route path="/news/:slug" element={<Guard><NewsArticlePage /></Guard>} />
                    <Route path="/scores" element={<Guard><ScoresPage /></Guard>} />
                    <Route path="/channels" element={<Guard><ChannelsPage /></Guard>} />
                    <Route path="/match/:id" element={<Guard><MatchDetailPage /></Guard>} />

                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </Suspense>
              </Layout>
            </Router>
            </FunnelProvider>
          </SubscriptionProvider>
        </AuthProvider>
      </LocaleProvider>
    </ThemeProvider>
  );
};

export default App;
